import { Outlet, useOutletContext } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AgentsHumansOnly from "./AgentsHumansOnly";

/**
 * Gate for every /agents route. An agent session gets the explanation
 * instead of the page; a person gets the page.
 *
 * `me` comes from AppShell's outlet context, so this costs no extra
 * request — and it waits for it, because rendering the page first would
 * fire a request the API 403s and flash an error before the swap.
 */
function AgentRoutes() {
  const context = useOutletContext() || {};
  const { me, meLoading } = context;

  if (meLoading) {
    return (
      <div className="py-12 text-center" role="status">
        <Loader2 className="inline size-6 animate-spin text-muted-foreground" />
        <span className="sr-only">Loading…</span>
      </div>
    );
  }
  // Unknown account is not a confirmed human — fail closed so a 5xx
  // on /users/me/ cannot render My token to an agent JWT.
  if (me?.kind !== "human") return <AgentsHumansOnly />;
  return <Outlet context={context} />;
}

export default AgentRoutes;
